import { render, staticRenderFns } from "./posting.vue?vue&type=template&id=a61ffe1e"
import script from "./posting.vue?vue&type=script&lang=js"
export * from "./posting.vue?vue&type=script&lang=js"
import style0 from "./posting.vue?vue&type=style&index=0&id=a61ffe1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports